<template>
  <validation-provider
    :name="$attrs.name"
    :rules="validationRules"
  >
    <b-form-group
      :label="$attrs.label"
      :label-for="$attrs.id"
      :label-class="{
        'custom-form-input-label--internal': internalPlatformInput,
        'custom-form-input-label': !internalPlatformInput,
        'pr-4': true
      }"
      :label-cols-sm="horizontal ? '3' : null"
      label-cols="12"
      :content-cols="widthXs || 12"
      :content-cols-sm="inputWidth"
      :content-cols-lg="widthLg || null"
      :label-align-sm="horizontal ? 'right' : ''"
      label-align="left"
    >
      <slot name="preInput" />
      <template
        v-if="hasTooltip"
        slot="label"
      >
        <div>
          {{ $attrs.label }}
          <span
            v-b-tooltip.hover.right
            :title="fetchTooltip($attrs.id)"
          >
            <font-awesome-icon
              class="ml-1 mt-1"
              :icon="['fas', 'question-circle']"
            />

          </span>
        </div>
      </template>

      <FileUploadList
        v-model="state"
        :accept="accept"
        :add-text="addText"      
        @fileSelected="fileSelected"
        @fileRemoved="fileRemoved"
      />
    </b-form-group>
  </validation-provider>
</template>

<script>
import FileUploadList from '@/components/common/FileUploadList.vue'
import formInputMixin from '@/mixins/formInputMixin'

export default {
  name: 'BaseFileUploadList',

  components: {
    FileUploadList,
  },

  mixins: [formInputMixin],

  inheritAttrs: false,

  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },

    lazy: {
      type: [Boolean, Number],
      default: 400
    },

    rules: {
      type: [String, Object],
      default: ''
    },

    accept: {
      type: String,
      default: null
    },

    addText: {
      type: String,
      default: 'Add'
    },  

    hasTooltip: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      syncTimeout: null
    }
  },

  computed: {
    state: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)

        if (this.lazy === true) {
          return
        }

        clearTimeout(this.syncTimeout)

        this.syncTimeout = setTimeout(
          () => {
            this.$emit('input', value)
          },
          this.lazy !== false ? this.lazy : 0
        )
      }
    },
  },

  methods:{
    fileSelected(value){  
      this.$emit('fileSelected', value)
    },

    fileRemoved(value){  
      this.$emit('fileRemoved', value)
    }

  }
}
</script>

<style>

</style>